import { SubtaskItemStatus } from '../constants';

const {
  PENDING,
  IN_PROGRESS,
  WAITING_FOR_SALES,
  WAITING_FOR_CUSTOMER,
  REJECT,
  CUSTOMER_REJECT,
  DONE,
  CLOSE,
  WAITING_FOR_NPD,
  APPROVE_BY_NPD,
} = SubtaskItemStatus;

const subtaskItemStatusRule = [
  {
    currentStatus: PENDING,
    nextStatus: [],
    subtaskTypeArtwork: {
      nextStatus: [IN_PROGRESS],
      previousStatus: [],
    },
    subtaskTypeProof: {
      nextStatus: [IN_PROGRESS],
      previousStatus: [],
    },
    subtaskTypeMockup: {
      nextStatus: [IN_PROGRESS],
      previousStatus: [],
    },
    subtaskTypeVerifyData: {
      nextStatus: [IN_PROGRESS],
      previousStatus: [],
    },
    isCommon: false,
  },
  {
    currentStatus: IN_PROGRESS,
    nextStatus: [],
    subtaskTypeArtwork: {
      nextStatus: [WAITING_FOR_NPD],
      previousStatus: [PENDING],
    },
    subtaskTypeProof: {
      nextStatus: [WAITING_FOR_CUSTOMER],
      previousStatus: [PENDING],
    },
    subtaskTypeMockup: {
      nextStatus: [WAITING_FOR_CUSTOMER],
      previousStatus: [PENDING],
    },
    subtaskTypeVerifyData: {
      nextStatus: [DONE],
      previousStatus: [PENDING],
    },
    isCommon: false,
  },
  {
    currentStatus: WAITING_FOR_NPD,
    nextStatus: [],
    subtaskTypeArtwork: {
      nextStatus: [APPROVE_BY_NPD],
      previousStatus: [PENDING, IN_PROGRESS],
    },
    subtaskTypeProof: {
      nextStatus: [],
      previousStatus: [],
    },
    subtaskTypeMockup: {
      nextStatus: [],
      previousStatus: [],
    },
    subtaskTypeVerifyData: {
      nextStatus: [],
      previousStatus: [],
    },
    isCommon: false,
  },
  {
    currentStatus: APPROVE_BY_NPD,
    nextStatus: [],
    subtaskTypeArtwork: {
      nextStatus: [WAITING_FOR_CUSTOMER],
      previousStatus: [WAITING_FOR_NPD],
    },
    subtaskTypeProof: {
      nextStatus: [],
      previousStatus: [],
    },
    subtaskTypeMockup: {
      nextStatus: [],
      previousStatus: [],
    },
    subtaskTypeVerifyData: {
      nextStatus: [],
      previousStatus: [],
    },
    isCommon: false,
  },
  {
    currentStatus: WAITING_FOR_CUSTOMER,
    nextStatus: [],
    subtaskTypeArtwork: {
      nextStatus: [CUSTOMER_REJECT, DONE],
      previousStatus: [APPROVE_BY_NPD],
    },
    subtaskTypeProof: {
      nextStatus: [DONE],
      previousStatus: [IN_PROGRESS],
    },
    subtaskTypeMockup: {
      nextStatus: [DONE],
      previousStatus: [IN_PROGRESS],
    },
    subtaskTypeVerifyData: {
      nextStatus: [],
      previousStatus: [],
    },
    isCommon: false,
  },
  {
    currentStatus: CUSTOMER_REJECT,
    nextStatus: [],
    subtaskTypeArtwork: {
      nextStatus: [],
      previousStatus: [WAITING_FOR_NPD],
    },
    isCommon: false,
  },
  { currentStatus: PENDING, nextStatus: [CLOSE, IN_PROGRESS], isCommon: true },
  { currentStatus: IN_PROGRESS, nextStatus: [CLOSE, WAITING_FOR_SALES], isCommon: true },
  {
    currentStatus: WAITING_FOR_SALES,
    nextStatus: [IN_PROGRESS, REJECT, CLOSE, WAITING_FOR_CUSTOMER],
    isCommon: true,
  },
  {
    currentStatus: WAITING_FOR_CUSTOMER,
    nextStatus: [CUSTOMER_REJECT, CLOSE, DONE],
    isCommon: true,
  },
  {
    currentStatus: DONE,
    nextStatus: [],
    subtaskTypeArtwork: {
      nextStatus: [],
      previousStatus: [CUSTOMER_REJECT],
    },
    isCommon: false,
  },
  {
    currentStatus: REJECT,
    nextStatus: [IN_PROGRESS, CLOSE],
    isCommon: true,
  },
  {
    currentStatus: CUSTOMER_REJECT,
    nextStatus: [IN_PROGRESS, CLOSE],
    isCommon: true,
  },
  {
    currentStatus: DONE,
    nextStatus: [],
    isCommon: true,
  },
  {
    currentStatus: CLOSE,
    nextStatus: [],
    isCommon: true,
  },
];

export default subtaskItemStatusRule;
